import { Injectable } from '@angular/core';
import { EmployerType } from '../../shared/enum/EmployerType'
import translateJson from "../../../translate.json";

const mailRegex = ""

@Injectable()
export class Formvalidator {

    formValidation: any;
    
    numberSpaceChar = new RegExp("^[A-Öa-ö0-9 -]*[A-Öa-ö0-9][A-Öa-ö0-9 -]*$");
    phoneValidator = new RegExp("^[+\\d ]+[+\\d -]+[\\d\\s]$"); 
    mailValidator = new RegExp("^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$");
    private i18 = translateJson.i18;

    /**
     * Constructor
     */
    constructor() {
        this.setDefault();
    }    

    /**
     * Set default values
     */
    setDefault() {
        this.formValidation = {        
            employerNameError: false,
            employerMailError: false,
            employerOrgIdError: false,
            employerPhoneError: false,
            suaError: false,
            postError: false,
            visitorAddressError: false,
            postCodeError: false,
            cityError: false,
            secManagerNameError: false,
            secManagerPhoneError: false,
            secManagerMailError: false,
            departmentError: false,
            admFormError: false,
            admManagerNameError: false,
            admManagerPhoneError: false,
            admManagerMailError: false,

            /* Local Offices */
            localOfficeAddressError: false,
            localOfficePostCodeError: false,
            localOfficeCountyError: false,
        }
    }

    /**
     * Validate create employer form
     * @param employerForm submission form
     */
    validateEmployerCreationForm(employerForm, employerAddressForm, securityManagerForm, admContactForm) {      
        if( !this.validateEmployerName(employerForm.name)
                && !this.validateEmployerOrgId(employerForm.organisationId, employerForm.countryCode)
                && !this.validateEmployerType(employerForm.employerType, employerForm.organisationId)
                && !this.validateEmployerMail(employerForm.contactMail)
                && !this.validateEmployerSua(employerForm.suaStatus)
                && !this.validateEmployerPhone(employerForm.contactPhone)
                && !this.validateEmployerAddress(employerAddressForm.address_1)
                && !this.validateEmployerPostalCode(employerAddressForm.postCode)
                && !this.validateEmployerCity(employerAddressForm.city) 
                && !this.validateSecManagerName(securityManagerForm.contactName)
                && !this.validateSecManagerPhone(securityManagerForm.contactPhone)
                && !this.validateSecManagerMail(securityManagerForm.contactMail) 
                && !this.validateAdmManagerName(admContactForm.contactName)
                && !this.validateAdmManagerPhone(admContactForm.contactPhone)
                && !this.validateAdmManagerMail(admContactForm.contactMail)) {                    
            return true;
        } else {
            return false;
        }
    }

    /**
     * Validate employer name
     * @param name employer name from form
     *       
     */
    validateEmployerName(name) {
        if(name != null && name.length > 1 && name.length < 255){
            return this.formValidation.employerNameError = false;
        } else {           
            return this.formValidation.employerNameError = true;
        }
    }

    /**
     * Validator function to verify that we send a department ID when create/update a employer
     * @param departmentId Department id    
     */
    validateEmployerDepartment(departmentId) {
        if(departmentId != undefined && departmentId != null && departmentId != NaN) {
            return this.formValidation.departmentId = false;
        } else {          
            return this.formValidation.departmentId = true;
        }
    }

    /**
     * Validator to assure a valid email address
     * @param mail Mail    
     */
    validateEmployerMail(mail) {
        if (mail === null || mail.trim().length < 1) {
            return this.formValidation.employerMailError = false;
        } else if (!this.isValidContactMail(mail)) {            
            return this.formValidation.employerMailError = true;
        }
        return this.formValidation.employerMailError = false;
    }

    /**
     * Validate organisation id
     * @param id employer name from form
     */
    validateEmployerOrgId(id, countryCode) {
        if(countryCode !== 'SE') {
            return this.formValidation.employerOrgIdError = false; 
        }

        if(id === null || id === "" || id === undefined) {           
            return this.formValidation.employerOrgIdError = true;
        }

        if(id.charAt(0) === '2' || id.charAt(0) === '3' || id.charAt(0) === '5' || id.charAt(0) === '6') {
            if(!(id.trim().replace(/\D/g, "").length === 10)) {                
                return this.formValidation.employerOrgIdError = true;
            }
        }

        id = id.match(/[0-9]{6}-[0-9]{4}/g);
            if(id === null){                
                return this.formValidation.employerOrgIdError = true;
            } else {
                id = id[0];
            }

            id = id
            .replace(/\D/g, "")     // strip out all but digits
            .split("")              // convert string to array
            .reverse()              // reverse order for Luhn

            // verify we got 10 digits, otherwise it is invalid
            if (id.length != 10) {               
                return this.formValidation.employerOrgIdError = true;
            }

            var sum = id
                // convert to number
                .map(function(n) {
                    return Number(n);
                })
                // perform arithmetic and return sum
                .reduce(function(previous, current, index) {
                    // multiply every other number with two
                    if (index % 2) current *= 2;
                    // if larger than 10 get sum of individual digits (also n-9)
                    if (current > 9) current -= 9;
                    // sum it up
                    return previous + current;
                });

            // sum must be divisible by 10   
            if (0 === sum % 10) {
                this.formValidation.ssnError = false;   
            } else {
                this.formValidation.ssnError = true;               
                return this.formValidation.employerOrgIdError = true;
            }
            
            return this.formValidation.employerOrgIdError = false;
    }

    /**
     * Validate employer sua (make sure a value is selected)
     * @param sua
     */
    validateEmployerSua(sua) {
        if(sua === "notApproved" || sua === "cancelled" || sua === "suaEmployer" || sua === "inBidding") {
            return this.formValidation.suaError = false;
        } else {        
            return this.formValidation.suaError = true;
        }
    }

    /**
     * Validate employer address
     * @param postaddress
     */
    validateEmployerAddress(postaddress) {
        if (postaddress === null || postaddress.trim().length < 1) {           
            return this.formValidation.postError = false; 
        } else if (postaddress.trim().length < 2) {
            return this.formValidation.postError = true; 
        } else {
            return this.formValidation.postError = false;  
        }
    }

    /**
     * Validate visitor address
     * @param postaddress 
     * @returns 
     */
    validateEmployerVisitorAddress(postaddress) {
        if (postaddress === null || postaddress.trim().length < 1) {           
            return this.formValidation.visitorAddressError = false; 
        } else if (postaddress.trim().length < 2) {
            return this.formValidation.visitorAddressError = true; 
        } else {
            return this.formValidation.visitorAddressError = false;  
        }
    }

    /**
     * Validate postal code
     * @param postnummer
     */
    validateEmployerPostalCode(postCode) {
        if (postCode === null || postCode.trim().length < 2) {         
            return this.formValidation.postCodeError = true;
        } 

        /*postCode = postCode.replace(" ", "")  // strip out all white spaces

        if (isNaN(postCode.trim())) {
            modalData[0] = "Fel i fält: Postnummer";
            modalData[1] = "Postnummer måste bestå av endast siffror för att godkännas.";
            return this.formValidation.postCodeError = true;  
        }*/
        return this.formValidation.postCodeError = false;                
    }

    /**
     * Validate city
     * @param postort
     */
    validateEmployerCity(postort) {
        if (postort === null || postort.trim().length < 2) {           
            return this.formValidation.cityError = true;   
        }
        return this.formValidation.cityError = false; 
    }

    /**
     * Validate employer phone number
     * @param number 
     * @returns 
     */
    validateEmployerPhone(number) {
        if (number === null || number.trim().length < 1) {
            return this.formValidation.employerPhoneError = false;
        } else if (!this.isValidPhoneNumber(number)) {           
            return this.formValidation.employerPhoneError = true;
        }
        return this.formValidation.employerPhoneError = false;
    }   

    validateSecManagerName(secName) {
        if (!this.isValidContactName(secName)) {           
            return this.formValidation.secManagerNameError = true;
        }
        
        return this.formValidation.secManagerNameError = false;
    }

    validateSecManagerPhone(secPhone) {
        if (secPhone === null || secPhone.trim().length < 1) {
            return this.formValidation.secManagerPhoneError = false;
        } else if (!this.isValidPhoneNumber(secPhone)) {           
            return this.formValidation.secManagerPhoneError = true;
        }
        return this.formValidation.secManagerPhoneError = false;
    }

    validateSecManagerMail(secMail) {
        if (secMail === null || secMail.trim().length < 1) {
            return this.formValidation.secManagerMailError = false;
        } else if (!this.isValidContactMail(secMail)) {           
            return this.formValidation.secManagerMailError = true;
        }
        return this.formValidation.secManagerMailError = false;
    }

    validateAdmManagerName(admName) {
        if (!this.isValidContactName(admName)) {            
            return this.formValidation.admManagerNameError = true;
        }
        return this.formValidation.admManagerNameError = false;
    }

    validateAdmManagerPhone(admPhone) {
        if (admPhone === null || admPhone.trim().length < 1) {
            return this.formValidation.admManagerPhoneError = false;
        } else if (!this.isValidPhoneNumber(admPhone)) {           
            return this.formValidation.admManagerPhoneError = true;
        }
        return this.formValidation.admManagerPhoneError = false;
    }

    validateAdmManagerMail(admMail) {
        if (admMail === null || admMail.trim().length < 1) {
            return this.formValidation.admManagerMailError = false;
        } else if (!this.isValidContactMail(admMail)) {            
            return this.formValidation.admManagerMailError = true;
        }
        return this.formValidation.admManagerMailError = false;
    }

    validateDepartment(department) {
        if(department === null || department === "") {
            return this.formValidation.departmentError = false;
        }
        if(department != null && this.numberSpaceChar.test(department)) {
            return this.formValidation.departmentError = false;
        } else {
            return this.formValidation.departmentError = true;
        }
    }

    validateEmployerType(type, organisationId) {
        if(organisationId.charAt(0) != '2') {
            return this.formValidation.employerTypeError = false;
        } else {
            if(type === EmployerType.GOVERNMENT || type === EmployerType.COUNTY || type === EmployerType.MUNICIPALITY || type === EmployerType.COMPANY) {
                return this.formValidation.employerTypeError = false;
            } else {              
                return this.formValidation.employerTypeError = true;
            }
        }
    }

    /**
     * Checks the validity of a phone number and sets modalData error message depending on the error.
     * @param phoneNumber A phone number.
     * @param modalData The modalData array.
     */
    isValidPhoneNumber(phoneNumber) {  
        if (phoneNumber === null || phoneNumber === "") {
            return false;
        }

        phoneNumber = phoneNumber.trim();      
        if (phoneNumber.trim().length < 5) {           
            return false;
        }
        else if (this.phoneValidator.test(phoneNumber)) {
            return true;
        }    
        return false;
    }

    /**
     * Checks the validity of a contact name and sets modalData error message appropriate to the name error.
     * @param contactName Name of the contact.    
     */
    isValidContactName(contactName) {
        if (contactName == null || contactName === "" || contactName.trim().length > 1) {
            return true;
        }      
        return false;
    }

    /**
     * Checks the validity of a contact mail and sets modalData error message appropriate to the mail error.
     * @param contactMail E-mail address.     *
     */
    isValidContactMail(contactMail) {
        if (contactMail == null || contactMail === "" || this.mailValidator.test(contactMail)) {
            return true;
        }      
        return false;
    }

    /**
     * localOfficeForm validation
     * @param localOfficeForm FormGroup
     */
    validateLocalOfficeForm(localOfficeForm) {     
        // lägg till koll för om samtliga fält är ikke angivna --> gråa ut lägg till knapp etc        
        if(this.validateLOAddress(localOfficeForm.address)
                && this.validateLOPostcode(localOfficeForm.postcode)
                && this.validateLOCounty(localOfficeForm.county)
            ) { return true; }
        return false;
    }

    /**
     * Validate the address field for Local Offices
     * @param address the local office address
     */
    validateLOAddress(address) {
        if (address.trim().length < 2) {
            this.formValidation.localOfficeAddressError = true;           
        } else {
            this.formValidation.localOfficeAddressError = false; 
        }
        return !this.formValidation.localOfficeAddressError;
    }

    /**
     * Validate the postcode field for Local Offices
     * @param postcode the local office postcode
     */
    validateLOPostcode(postcode) {
        if (postcode.trim().length < 2) {
            this.formValidation.localOfficePostCodeError = true;           
        } else {
            this.formValidation.localOfficePostCodeError = false; 
        }
        return !this.formValidation.localOfficePostCodeError;
    }

    /**
     * Validate the county field for Local Offices
     * @param county the local office county
     */
    validateLOCounty(county) {
        if (county.trim().length < 2) {
            this.formValidation.localOfficeCountyError = true;           
        } else {
            this.formValidation.localOfficeCountyError = false; 
        }
        return !this.formValidation.localOfficeCountyError;
    }
    
}
